var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.poi_data)?_c('div',_vm._l((_vm.$store.state.poi_data),function(station,ind){return _c('div',{key:ind + 'poly'},[(station.geom && _vm.selected_obj)?_c('div',[_c('l-geo-json',{attrs:{"geojson":{
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: JSON.parse(station.geom),
              properties: station,
            },
          ],
        },"options":{ 
          style: () => ({
            fillColor: 'transparent',
            color: _vm.selected_obj.legend[station[_vm.selected_radio_group]],
            zIndex: 1 // Include all styles here
          }),
          onEachFeature: _vm.onEachFeature 
        }}})],1):_vm._e()])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }